import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section id="cta" className="py-20 bg-primary">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
        Mindre kostnader. Mer intäkter
        </h2>
        <Button 
          variant="accent" 
          size="xl"
          className="text-black"
          onClick={() => window.location.href = '/contact'}
        >
          Boka kostnadsfritt möte idag
        </Button>
      </div>
    </section>
  );
};

export default CTASection;